import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '实物条码', width: null },
  { prop: 'strCarCode', label: '长(CM)', width: null },
  { prop: 'strCarCode', label: '宽(CM)', width: null },
  { prop: 'strResolveTime', label: '高(CM)', width: null },
  { prop: 'strResolveTime', label: '体积重(KG)', width: null },
  { prop: 'strResolveTime', label: '扫描时间', width: null },
  { prop: 'strState', label: '状态', width: null },
  { prop: 'strTip', label: '提示/警告信息', width: null },
];
export default { tableHeader }
